<style scoped>
</style>
<template>
  <list ref="list"></list>
</template>

<script>
  import list from "../../../components/approval/list";
  export default {
    name: "handle",//审批
    components: {list},
  }
</script>
